import React, { useEffect, useState } from 'react';

// Permanent warning strip for non-production servers (e.g. the AWS development server).
// Shown only when the API reports APP_DEV_BANNER=true, so no frontend rebuild is needed to turn it on or off.
const CACHE_KEY = 'app_dev_banner';
const DEFAULT_TEXT = 'Sistem ini untuk ujian sahaja. Data dan emel mungkin tidak sebenar; jangan gunakan untuk urusan rasmi.';

const readCache = () => {
    try {
        return JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
    } catch (e) {
        return null;
    }
};

const SharedDevServerBanner = () => {
    const [banner, setBanner] = useState(readCache);

    useEffect(() => {
        const apiUrl = process.env.REACT_APP_API_URL;
        if (!apiUrl) return undefined;
        let cancelled = false;
        fetch(`${apiUrl}/app-info`, { headers: { Accept: 'application/json' } })
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => {
                if (cancelled || !data) return;
                const next = data.dev_banner || { enabled: false };
                setBanner(next);
                try {
                    sessionStorage.setItem(CACHE_KEY, JSON.stringify(next));
                } catch (e) {
                    // Storage unavailable: the banner still shows for this page view.
                }
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, []);

    const enabled = Boolean(banner?.enabled);

    useEffect(() => {
        document.documentElement.classList.toggle('has-dev-banner', enabled);
        return () => document.documentElement.classList.remove('has-dev-banner');
    }, [enabled]);

    if (!enabled) return null;

    return (
        <div className="app-dev-banner" role="status">
            <i className="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
            <strong>PELAYAN PEMBANGUNAN</strong>
            <span>{banner.text || DEFAULT_TEXT}</span>
        </div>
    );
};

export default SharedDevServerBanner;
